module.exports = __webpack_public_path__ + "img/landingImageCableCloserLonger.0e8c29c8.svg";